import React, { useCallback } from 'react';
import { LoadingOutlined } from '@ant-design/icons';

import { useUserStore } from '../stores';
import { useInitialCheckAuthentication } from '../hooks';
import { AuthorizationContext } from './AuthorizationContext';
import { authService } from '../services/auth-service';

export const AuthorizationContextProvider = ({
  children,
  FallbackApp,
}: React.PropsWithChildren<{ FallbackApp: JSX.Element }>) => {
  const { user, isInitializing, clearAuth } = useUserStore();
  useInitialCheckAuthentication();

  const logout = useCallback(async () => {
    try {
      await authService.logout();
    } catch (error) {
      console.error('Logout request failed:', error);
    } finally {
      clearAuth();
      if (window.location.pathname !== '/') {
        window.location.replace('/');
      }
    }
  }, [clearAuth]);

  if (isInitializing) {
    return <LoadingOutlined />;
  }

  if (!user) {
    return FallbackApp;
  }

  const value = { state: { user }, dispatch: { logout } };
  return <AuthorizationContext.Provider value={value}>{children}</AuthorizationContext.Provider>;
};
